import type { Mission } from '../missions.ts'

export const uscg: Mission = {
  id: "uscg",
  name: "U.S. Coast Guard",
  short: "USCG",
  kind: "subagency",
  parent: "dhs",
  url: "https://www.uscg.mil/",
  established: 1790,
  palette: {
    primary: "#041e42",
    secondary: "#006ba6",
    accent: "#e03c31",
  },
  colorSource: {
    kind: "site",
    url: "https://www.uscg.mil/",
  },
  motif: "anchor",
  mission: {
    text: "The Coast Guard conducts the full range of statutory missions to deliver results, focused on achieving four paramount mission objectives across four operational domains that make up the U.S. homeland.",
    url: "https://www.uscg.mil/",
  },
  fact: {
    text: "The Coast Guard traces its history to August 4, 1790, when Congress authorized ten vessels to enforce tariff and trade laws.",
    url: "https://www.history.uscg.mil/home/history-program/",
  },
  seal: {
    file: "public/seals/uscg.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Coast_Guard.svg",
  },
  identifier: {
    about: "https://www.uscg.mil/About/",
    accessibility: "https://www.uscg.mil/access/",
    foia: "https://www.dcms.uscg.mil/Our-Organization/Assistant-Commandant-for-C4IT-CG-6/The-Office-of-Information-Management-CG-61/FOIA-Library/",
    noFear: "https://www.uscg.mil/no_fear/",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.uscg.mil/Budget/",
    privacy: "https://www.uscg.mil/Disclaim/",
  },
  media: {
    photos: [
      {
        file: "/media/uscg-eagle-baltimore.jpg",
        small: "/media/uscg-eagle-baltimore-sm.jpg",
        alt: "The white three-masted barque Eagle, with the Coast Guard racing stripe on its bow, enters Baltimore Harbor under a partly cloudy sky.",
        title: "USCGC Eagle (WIX 327) pulls into Baltimore Harbor for Sail 250 Maryland, June 25, 2026",
        creator: "Petty Officer 3rd Class Greggory Fisher, U.S. Coast Guard",
        source: "https://commons.wikimedia.org/wiki/File:USCGC_Eagle_(WIX_327)_Pulls_Into_Baltimore_Harbor_for_Sail_250_Maryland_(9773469).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/uscg-eagle-sails.jpg",
        small: "/media/uscg-eagle-sails-sm.jpg",
        alt: "Looking up through the rigging and white sails of the Coast Guard Cutter Eagle, with the sun flaring through the canvas.",
        title: "Coast Guard Cutter Eagle under sail in the Atlantic Ocean, May 16, 2024",
        creator: "Petty Officer 1st Class Matthew West, U.S. Coast Guard",
        source: "https://commons.wikimedia.org/wiki/File:Coast_Guard_Cutter_Eagle_under_sail_(8819402).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
    video: {
      webm: "/media/uscg-loop.webm",
      mp4: "/media/uscg-loop.mp4",
      poster: "/media/uscg-loop-poster.jpg",
      title: "USCGC Eagle departs New York Harbor for Sail 250 Boston, July 8, 2026",
      creator: "Petty Officer 3rd Class Justin Remo, U.S. Coast Guard",
      source: "https://commons.wikimedia.org/wiki/File:B-Roll_edit_-_USCGC_Eagle_and_NS_Mircea_departing_New_York.webm",
      license: "Public domain (U.S. government work)",
    },
  },
}
